import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { HiOutlineArrowRight, HiTag } from "react-icons/hi2";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { baseurl, imgurl } from "../../baseurl";
import { Link } from "react-router-dom";

// Swiper Styles
import "swiper/css";
import "swiper/css/pagination";
import "../../asset/css/packages.css";

const YatraPackages = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Filter logic: Only keep packages where type matches "Yatra Package"
  const filteredPackages = useMemo(() => {
    return packages.filter((pkg) => pkg.package_type === "Yatra Package");
  }, [packages]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await axios.get(`${baseurl}/getAllPackages`);
        if (response.data.status === "success") {
          setPackages(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching packages:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPackages();
  }, []);

  if (loading) {
    return <div className="text-center py-5">Loading amazing deals...</div>;
  }

  const renderPackageCard = (pkg) => (
    <div className="package-card shadow-sm h-100">
      <div className="package-img-wrapper">
        <img
          src={`${imgurl}/uploads/${pkg.banner_path}`}
          alt={pkg.package_name}
          className="package-img"
        />
        <div className="package-badge">{pkg.package_type}</div>
        <div className="package-price-tag">
          <span className="currency">₹</span>
          {pkg.price}
        </div>
      </div>

      <div className="package-content p-4">
        <h4 className="package-title mb-3">{pkg.package_name}</h4>
        <p className="package-desc text-muted mb-4">
          {pkg.package_description?.substring(0, 80)}...
        </p>

        <div className="package-footer d-flex justify-content-between align-items-center pt-3 border-top">
          <div className="d-flex align-items-center text-teal fw-bold">
            <HiTag className="me-1" /> Best Price
          </div>
          <Link to={`/package/${pkg.id}`} className="btn-details">
            View Details <HiOutlineArrowRight className="ms-1" />
          </Link>
        </div>
      </div>
    </div>
  );

  return (
    <section className="popular-packages-section container py-5">
      <div className="section-header text-center mb-5">
        <h6 className="text-teal fw-bold letter-spacing-2 text-uppercase">
          Exclusive Offers
        </h6>
        <h2 className="display-5 fw-bold">Popular Yatra Packages</h2>
        <div className="underline mx-auto"></div>
      </div>

      {filteredPackages.length > 0 ? (
        isMobile ? (
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={20}
            slidesPerView={1.2}
            centeredSlides={true}
            loop={filteredPackages.length > 1} // Only loop if more than 1 card
            autoplay={{ delay: 3000 }}
            pagination={{ clickable: true }}
            className="mobile-package-swiper"
          >
            {filteredPackages.map((pkg) => (
              <SwiperSlide key={pkg.id}>
                {renderPackageCard(pkg)}
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <div className="row g-4">
            {filteredPackages.map((pkg) => (
              <div className="col-lg-4 col-md-6" key={pkg.id}>
                {renderPackageCard(pkg)}
              </div>
            ))}
          </div>
        )
      ) : (
        <div className="text-center text-muted">
          No Yatra Packages available at the moment.
        </div>
      )}
    </section>
  );
};

export default YatraPackages;